import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import RatePlan from "../ratePlan/RatePlan";
import DateRange from "../dateRange/DateRange";
import {
  selectManageARIDateRange,
  setManageARIDateRange,
} from "../../slices/ariDateRangeSlice";
import { selectSelectedRateplan } from "../../slices/rateplanSlice";
import "./manageari.scss";

const ManageAri = () => {
  const storeDateRange = useSelector(selectManageARIDateRange);
  const [dateRange, setDateRange] = useState(storeDateRange);
  const selectedRateplanDetail = useSelector(selectSelectedRateplan);
  const dispatch = useDispatch();

  useEffect(() => {
    setDateRange(storeDateRange);
  }, [storeDateRange]);

  // Automatically dispatch date range when both rateplan and date range are selected
  useEffect(() => {
    if (selectedRateplanDetail && dateRange && dateRange.length === 2) {
      dispatch(setManageARIDateRange(dateRange));
    }
  }, [dateRange, selectedRateplanDetail, dispatch]);

  return (
    <div className="manageari-container">
      <RatePlan data-testid="rate-plan-component" />
      <DateRange
        value={dateRange}
        setValue={setDateRange}
        label={null}
        data-testid="date-range-component"
      />
    </div>
  );
};

export default ManageAri;
